import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/notification`;

export default {
  index(payload) {
    return Client.get(`${resource}`, {
      params: payload,
    });
  },
  countUnread(payload) {
    return Client.get(`${resource}/count/unread`, {
      params: payload,
    });
  },
  read(payload) {
    return Client.post(`${resource}/read`, payload);
  },
  readall() {
    return Client.post(`${resource}/readall`);
  },
  getVoiceSound() {
    return Client.post(`${resource}/voice/sound`, payload);
  },
};
